<style scoped>
.drop-element {
  color: #cccccc;
  text-align: center;
  width: 100%;
}
.empty-emoji {
  font-size: 80px;
  display: block;
}
.drop.over {
  border: 0px dashed #cccccc;
}
</style>
<template>
<div>
  <div xs12 v-if="loading === true" style="padding-top: 250px; width: 100%; text-align: center">
    <v-progress-circular
      :size="70"
      :width="7"
      color="blue-grey"
      indeterminate
    ></v-progress-circular>

  </div>
  <div v-if="loading !== true">
    <v-flex xs12 v-if="display == 'success'">
      <v-alert
        :value="true"
        dismissible
        type="success"
      >{{ message ? message : 'Form submission successful'}}</v-alert>
    </v-flex>
    <v-flex xs12 class="text-xs-center" v-if="addAnotherButton == true">
      <v-btn dark v-on:click="addAnother()"> Add Another </v-btn>
    </v-flex>
    <v-flex xs12 v-if="display == 'error'">
      <v-alert :value="true" type="error">{{ message ? message : 'Form submission failed'}}</v-alert>
    </v-flex>


    <v-flex xs12 v-if="display != 'success'">
      <v-form ref="form" v-model="valid">
        <grid-layout
          v-if="layout && layout.length"
          :layout.sync="layout"
          :col-num="12"
          :row-height="5"
          :is-draggable="false"
          :is-resizable="false"
          :is-mirrored="false"
          :vertical-compact="true"
          :margin="[10, 10]"
          :use-css-transforms="true"
        >
        <template v-for="(item, index) in layout">
          <grid-item
            :x="item.x"
            :y="item.y"
            :w="item.w"
            :h="item.h"
            :i="item.i"
            :key="item.i"
            v-if="item.element && item.element.id"
          >

          <div v-if="!item.element">{{ JSON.stringify(item) }}</div>
            <div style="width: 100%; height: 100%;" v-if="item.element && item.element.id">
              <form-element :element="item.element"  :index="index" :chart="chart" :display="'view'" :key="item.element.id"></form-element>
            </div>
          </grid-item>
        </template>
        </grid-layout>
      </v-form>
    </v-flex>
  </div>
  </div>
</template>
<script>
import { Drop } from "vue-drag-drop";
import VueGridLayout from "vue-grid-layout";
import Element from "./element.vue";

export default {
  props: ["chart", "layoutInput"],
  data: function () {
    return {
      valid: true,
      addAnotherButton: false,
      loading: false,
      status: {
        loadingData: false
      },
      over: false,
      display: null,
      message: "",
      activeElement: null,
      default: {
        x: 0,
        y: 0,
        w: 12,
        h: 2,
        i: "0",
        element: { code: "first" },
      },
      layout: [],
    };
  },
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    "form-element": Element,
  },
  methods: {
    addAnother: function() {
      try {
        this.display = null;
        this.chart.hydrate();
        // this.$refs.form.reset();
      } catch(error) {
        console.log("error");
      }
    },
    gridClicked: function (item) {
      // alert("Clicked");
      this.chart.setActiveGrid(item);
      this.chart.save(this.layout);
    },
    remove() {
      if (this.activeElement) {
        this.layout = this.layout.filter((item) => item.id != grid.id);
        this.chart.layout = this.layout;
        this.chart.save(this.layout);
      }
    },
    handleFirstDrop(transferData) {
      const newItem = { ...this.default };
      newItem.element = transferData.data;
      this.layout.push(newItem);
    },
    handleDrop(item, transferData) {
      // const element = transferData.data;
      // if (typeof element.create != "undefined") {
      //   let grid = element.create();
      //   grid.w = 8
      //   grid.h = 6;
      //   grid.height = 6;
      //   console.log("new grid", grid);
      //   const newItem = { ...this.default };
      //   if (item) {
      //     grid.x = item.x + 1;
      //     const index = this.layout.indexOf(item);
      //     this.layout.splice(index + 1, 0, grid);
      //     this.chart.setActiveElement(grid);
      //   } else {
      //     console.log("adding 1", grid);
      //     this.layout.push(grid);
      //     console.log("added 3", this.layout);
      //     this.chart.setActiveElement(grid);
      //   }
      // }

      this.layout = this.chart.layout;
      this.chart.addElement(item, transferData.data);
      this.chart.save(this.layout);
      // alert("drop");
      // this.over = null;
      // // data.element = transferData;
      // let newItem = {...item};
      // newItem.h = 2;
      // if(typeof transferData.data.grid != "undefined") {
      //   newItem = {...newItem, ...transferData.data.grid};
      // }
      // newItem.element = transferData.data;
      // newItem.x = newItem.x+1;
      // const index = this.layout.indexOf(item);
      // newItem.i = "New " + index;
      // this.layout.splice(index+1, 0, newItem);
      // console.log("newItem", newItem);
      // alert(index);
      // alert(`You dropped with data: ${JSON.stringify(data)}`);
    },
    appendElement() {},
  },
  computed: {},
  mounted: function () {
    const that = this;

    this.chart.$formRef = this.$refs.form;

    this.loading = this.chart.status.loadingData;
    this.chart.setLoading = function(loading) {
      that.loading = loading;
    }

    this.chart.getForm = function () {
      return that.$refs.form;
    };

    // console.log("this.chart.layout", this.chart.layout);

    this.chart.success = function (triggerElement) {
      that.message = triggerElement.successMessage;
      that.addAnotherButton = false;
      if(triggerElement.functionType == "dataAddTable") {
        that.addAnotherButton = true;
      }
      that.display = "success";
    };
    this.chart.error = function (triggerElement) {
      that.message = triggerElement.errorMessage;
      that.display = "error";
    };

    this.chart.getPostData = function () {
      return that.layout;
    };
    // this.chart.layout = this.layout;
    // alert("mounted");
    // console.log(that.layout);
    this.chart.setViewLayout = function (layout) {
      that.layout = layout;
      // alert("view layout");
      // console.log("updating view layout", that.layout);
    };
    if(typeof this.chart.loadFromSchema != "undefined") {
      this.chart.loadFromSchema(true);
    }
    
    //console.log("first view layout", that.layout);
    // this.chart.setLayout = function (layout) {
    //   that.layout = layout;
    //   console.log("updating layout", this.layout);
    // };

    // this.chart.appendLayout = function (item, newItem) {
    //   // this.layout = layout;
    //   console.log("updating layout", this.layout);
    // };

    // this.chart.loadFromSchema();

    // var arr = [];
    // arr[0] = "Jani";
    // arr[1] = "Hege";
    // arr[2] = "Stale";
    // arr[3] = "Kai Jim";
    // arr[4] = "Borge";

    // console.log(arr.join());
    // arr.splice(2, 0, "Lene");
    // console.log(arr.join());
  },
  beforeDestroy() {},
};
</script>
